import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faMobile as faMobileReg } from '@fortawesome/pro-regular-svg-icons';
import { faMobile as faMobileSolid } from '@fortawesome/pro-solid-svg-icons';

@Enum<MobileStatusType>('value')
export class MobileStatusType extends EnumType<MobileStatusType>() {
   public static readonly None = new MobileStatusType('NONE', 0x0000, faMobileReg, 'state-none', 'samwin.contact-status.types.line_status_types.none', false);

   public static readonly Idle = new MobileStatusType('IDLE', 0x0001, faMobileSolid, 'state-idle', 'samwin.contact-status.types.line_status_types.idle');

   public static readonly Offering = new MobileStatusType(
      'OFFERING',
      0x0002,
      faMobileSolid,
      'state-offering',
      'samwin.contact-status.types.line_status_types.offering'
   );

   public static readonly Accepted = new MobileStatusType(
      'ACCEPTED',
      0x0004,
      faMobileSolid,
      'state-accepted',
      'samwin.contact-status.types.line_status_types.accepted'
   );

   public static readonly Dialtone = new MobileStatusType(
      'DIALTONE',
      0x0008,
      faMobileSolid,
      'state-dialtone',
      'samwin.contact-status.types.line_status_types.dialtone'
   );

   public static readonly Dialing = new MobileStatusType(
      'DIALING',
      0x0010,
      faMobileSolid,
      'state-dialing',
      'samwin.contact-status.types.line_status_types.dialing'
   );

   public static readonly Ringback = new MobileStatusType(
      'RINGBACK',
      0x0020,
      faMobileSolid,
      'state-ringback',
      'samwin.contact-status.types.line_status_types.ringback'
   );

   public static readonly Busy = new MobileStatusType('BUSY', 0x0040, faMobileSolid, 'state-busy', 'samwin.contact-status.types.line_status_types.busy');

   public static readonly Connected = new MobileStatusType(
      'CONNECTED',
      0x0100,
      faMobileSolid,
      'state-connected',
      'samwin.contact-status.types.line_status_types.connected'
   );

   public static readonly Proceeding = new MobileStatusType(
      'PROCEEDING',
      0x0200,
      faMobileSolid,
      'state-proceeding',
      'samwin.contact-status.types.line_status_types.proceeding'
   );

   public static readonly OnHold = new MobileStatusType(
      'ON_HOLD',
      0x0400,
      faMobileSolid,
      'state-on-hold',
      'samwin.contact-status.types.line_status_types.on_hold'
   );

   public static readonly Conferenced = new MobileStatusType(
      'CONFERENCED',
      0x0800,
      faMobileSolid,
      'state-conferenced',
      'samwin.contact-status.types.line_status_types.conferenced'
   );

   public static readonly OnHoldPendingConference = new MobileStatusType(
      'ON_HOLD_PENDING_CONFERENCE',
      0x1000,
      faMobileSolid,
      'state-on-hold-pending-conference',
      'samwin.contact-status.types.line_status_types.on_hold_pending_conference'
   );

   public static readonly OnHoldPendingTransfer = new MobileStatusType(
      'ON_HOLD_PENDING_TRANSFER',
      0x2000,
      faMobileSolid,
      'state-on-hold-pending-transfer',
      'samwin.contact-status.types.line_status_types.on_hold_pending_transfer'
   );

   public static readonly Disconnected = new MobileStatusType(
      'DISCONNECTED',
      0x4000,
      faMobileSolid,
      'state-disconnected',
      'samwin.contact-status.types.line_status_types.disconnected'
   );

   public static readonly Unknown = new MobileStatusType(
      'UNKNOWN',
      0x9999,
      faMobileReg,
      'state-unknown',
      'samwin.contact-status.types.line_status_types.unknown',
      false
   );

   private constructor(
      public value: string,
      public databaseValue: number,
      public statusIcon: IconDefinition,
      public styleClass: string,
      public translationKey: string,
      public displayTextDefault: boolean = true
   ) {
      super();
   }

   public static getPresenceStatusByDatabaseValue(databaseValue: number): MobileStatusType {
      const allValues = MobileStatusType.values();
      const value = _(allValues)
         .filter((x) => x.databaseValue === databaseValue)
         .head();
      return value ? value : MobileStatusType.Unknown;
   }
}
